import { useMemo, useState } from "react";
import { HiShoppingCart } from "react-icons/hi";
import { TbCurrencyTaka } from "react-icons/tb";
import QuickAddDrawer from "./quickAddDrawer";
import { useNavigate } from "react-router-dom";
import { FaCartPlus } from "react-icons/fa";
import StockOut from "./stockOut";
import NoDataView from "./noDataView";
import { getCartItems, setCartItems } from "utils/cartStorage";

const CardDesign = ({ likeData, loading, error }) => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  // 🔥 Memoized filtered products (prevents recalculation)
  const products = useMemo(() => {
    return (likeData || []).filter((item) => item.hideStatus === "available");
  }, [likeData]);

  const addToCart = (item) => {
    const existingItems = getCartItems();

    const key = item.item_id || item.title;
    const existingIndex = existingItems.findIndex(
      (p) => (p.item_id || p.title) === key,
    );

    const firstVariant = item.variants?.[0] || {};

    const colorArray = item.color
      ? item.color.split(",").map((s) => s.trim())
      : [];

    const sizeArray = item.size
      ? item.size.split(",").map((s) => s.trim())
      : [];

    const selectedColor = colorArray[0] || "";
    const selectedSize = sizeArray[0] || "";
    const selectedTitle = firstVariant.title || "";
    const selectedPrice = firstVariant.flashPrice || 0;

    // ✅ FIRE TAG HERE
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "BDT",
        value: selectedPrice,
        items: [
          {
            item_id: item.item_id,
            item_name: firstVariant.title,
            price: selectedPrice,
            item_category: item.catalogue_title,
            quantity: 1,
          },
        ],
      },
    });

    console.log("add_to_cart fired");

    if (existingIndex !== -1) {
      existingItems[existingIndex] = {
        ...existingItems[existingIndex],
        quantity: (existingItems[existingIndex].quantity || 1) + 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
      };
    } else {
      existingItems.push({
        ...item,
        quantity: 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
        selectedVariant: firstVariant,
      });
    }

    setCartItems(existingItems);
  };

  if (loading)
    return (
      <div className="flex justify-center items-center text-[#265fc9] p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#265fc9]"></div>
      </div>
    );

  return (
    <div className="container mx-auto px-4 sm:px-6 md:px-10">
      <div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {products?.length ? (
            products.map((item, index) => {
              const isOutOfStock = item.status === "unavailable";
              // ✅ Split title and flashPrice per product
              const firstVariant = item.variants?.[0] || {};
              const firstImage = firstVariant.images?.[0]?.thumb || "";

              const selectedTitle = firstVariant.title || "-";
              const selectedPrice = firstVariant.flashPrice || 0;
              const selectedDiscount = firstVariant.discount || 0;
              const originalPrice = selectedDiscount || 0;
              const flashPrice = selectedPrice || 0;

              const discountPercent =
                originalPrice > 0
                  ? Math.ceil(
                      ((originalPrice - flashPrice) / originalPrice) * 100,
                    )
                  : 0;
              return (
                <div
                  key={index}
                  className={`relative flex flex-col flex-shrink-0 lg:w-[280px] md:w-[240px] max-md:basis-[47%] bg-white rounded-[10px] overflow-hidden transition-transform duration-200 
                                        ${isOutOfStock ? "opacity-40" : ""}
                                    `}
                >
                  {isOutOfStock && <StockOut />}

                  <a href={`/details/${item.catalogue}/${item.item_id}`}>
                    <div className="relative group aspect-product-desktop w-full overflow-hidden">
                      <img
                        src={`https://backend.nuhababy.com/${firstImage}`}
                        alt={selectedTitle}
                        loading={index < 4 ? "eager" : "lazy"}
                        fetchPriority={index === 0 ? "high" : "auto"}
                        decoding="async"
                        width={315}
                        height={460}
                        className="w-full h-full object-cover transition-transform duration-1000 ease-in-out transform group-hover:scale-105 cursor-pointer rounded-t-[10px]"
                      />
                      {discountPercent > 0 && (
                        <div className="absolute top-0 left-0 w-20 h-20 overflow-hidden z-10">
                          <div className="absolute top-[18px] -left-[28px] rotate-[-45deg] bg-red-500 text-white text-[10px] md:text-xs font-bold w-32 text-center py-1 shadow-md">
                            {discountPercent}% OFF
                          </div>
                        </div>
                      )}
                      {firstVariant.freeVariantDelivery === 1 && (
                        <div className="absolute top-2 right-2">
                          <div className="flex items-center gap-1 px-2 md:h-8 h-6 bg-blue-600  text-white rounded-md text-[10px] md:text-xs font-semibold shadow">
                            🚚 <span>ফ্রি ডেলিভারী</span>
                          </div>
                          {/* <div className="flex items-center gap-1 px-2 md:h-8 h-6 bg-blue-600  text-white rounded-md text-[10px] md:text-xs font-semibold shadow">
                              🚚 Free Delivery
                            </div> */}
                        </div>
                      )}
                    </div>
                  </a>

                  <div className="md:px-3 p-2 flex flex-col flex-grow">
                    <div className="text-black hover:text-[#222836] hover:opacity-60 font-medium tracking-wide mb-1 text-sm whitespace-nowrap overflow-hidden truncate">
                      {item?.mainTitle}
                    </div>
                    <div className="text-black hover:text-[#222836] hover:opacity-60 tracking-wide mb-1 text-xs whitespace-nowrap overflow-hidden truncate">
                      {selectedTitle}
                    </div>
                    <div className="flex pb-2">
                      <div className="relative inline-flex items-center text-gray-400 text-sm mr-2">
                        <span className="flex items-center">
                          <p>{selectedDiscount}</p>
                          <TbCurrencyTaka className="font-semibold" />
                        </span>
                        <div className="absolute left-0 right-0 top-1/2 h-[1px] bg-gray-400"></div>
                      </div>
                      <div className="flex text-[#265fc9] items-center text-sm">
                        <p className="font-bold">{selectedPrice}</p>
                        <TbCurrencyTaka className="font-semibold" />
                      </div>
                    </div>

                    {!isOutOfStock && (
                      <div className="flex gap-2 my-1 mt-auto">
                        <button
                          lang="bn"
                          onClick={(e) => {
                            addToCart(item);
                            navigate("/orderDetails");
                          }}
                          className="md:text-base text-sm flex-1 text-white bg-backgroundColor border border-darkBgColor rounded-md md:px-4 px-2 py-1 md:font-bold font-semibold flex justify-center items-center"
                        >
                          অর্ডার করুন
                        </button>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            addToCart(item);
                            setDrawerOpen(true);
                          }}
                          className="md:px-3 px-2 rounded-md border text-darkBgColor py-1"
                        >
                          <span className="group-hover:hidden md:text-base text-sm">
                            <FaCartPlus />
                          </span>
                          <HiShoppingCart className="hidden group-hover:block w-5 h-5" />
                        </button>
                      </div>
                    )}
                    <QuickAddDrawer
                      isOpen={drawerOpen}
                      onClose={() => setDrawerOpen(false)}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <NoDataView title="কোনো পণ্য পাওয়া যায়নি" />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardDesign;
